import React from "react";
import { ArrowUp, Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { navLinks, institutions, site } from "../mock/mock";
import { nav } from "../mock/pages";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer style={{ background: "var(--teal-900)" }}>
      <div className="mx-auto max-w-[1280px] px-5 py-16 lg:px-6">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_0.7fr_0.7fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <Logo variant="dark" height={54} />
            </div>
            <p className="mt-6 max-w-sm text-[0.88rem] leading-relaxed" style={{ color: "rgba(251,247,240,.62)" }}>
              A CBSE school in Coimbatore where excellence, values and integrity shape leaders — set on a
              160+ acre campus built for curiosity.
            </p>
            <div className="mt-7 flex gap-3">
              {[Facebook, Instagram, Youtube, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Social link"
                  className="grid h-10 w-10 place-items-center rounded-full"
                  style={{
                    border: "1px solid rgba(251,247,240,.2)",
                    color: "rgba(251,247,240,.8)",
                    transition: "background .3s ease, border-color .3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "var(--gold)";
                    e.currentTarget.style.borderColor = "var(--gold)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.borderColor = "rgba(251,247,240,.2)";
                  }}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="eyebrow" style={{ color: "var(--gold-200)", fontSize: "0.7rem" }}>
              Explore
            </h4>
            <ul className="mt-6 space-y-3">
              {nav.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[0.88rem]"
                    style={{ color: "rgba(251,247,240,.66)", transition: "color .25s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#FBF7F0")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(251,247,240,.66)")}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/downloads"
                  className="text-[0.88rem]"
                  style={{ color: "rgba(251,247,240,.66)", transition: "color .25s ease" }}
                >
                  Downloads
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="eyebrow" style={{ color: "var(--gold-200)", fontSize: "0.7rem" }}>
              KPR Institutions
            </h4>
            <ul className="mt-6 space-y-3">
              {institutions.map((i) => (
                <li key={i.short}>
                  <a
                    href={i.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-[0.88rem]"
                    style={{ color: "rgba(251,247,240,.66)", transition: "color .25s ease" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#FBF7F0")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(251,247,240,.66)")}
                  >
                    {i.short} — {i.type}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="eyebrow" style={{ color: "var(--gold-200)", fontSize: "0.7rem" }}>
              Reach Us
            </h4>
            <p className="mt-6 text-[0.88rem] leading-relaxed" style={{ color: "rgba(251,247,240,.66)" }}>
              {site.address}
            </p>
            <a href={`tel:${site.hotlines[0].replace(/\s/g, "")}`} className="mt-4 block text-[0.9rem]" style={{ color: "var(--gold-200)" }}>
              {site.hotlines[0]}
            </a>
            <a href={`tel:${site.hotlines[1].replace(/\s/g, "")}`} className="mt-1 block text-[0.9rem]" style={{ color: "var(--gold-200)" }}>
              {site.hotlines[1]}
            </a>
            <a href={`https://wa.me/${site.whatsapp}`} target="_blank" rel="noreferrer" className="mt-1 block text-[0.9rem]" style={{ color: "var(--gold-200)" }}>
              WhatsApp on both hotline numbers
            </a>
            <a href={`mailto:${site.email}`} className="mt-1 block text-[0.9rem]" style={{ color: "var(--gold-200)" }}>
              {site.email}
            </a>
          </div>
        </div>

        <div className="hairline-gold my-10" />

        <div className="flex flex-col items-center justify-between gap-5 sm:flex-row">
          <p className="text-[0.78rem]" style={{ color: "rgba(251,247,240,.45)" }}>
            © {new Date().getFullYear()} The KPR Academy. All rights reserved.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 text-[0.78rem] font-semibold"
            style={{ color: "rgba(251,247,240,.7)" }}
          >
            Back to top
            <span
              className="grid h-8 w-8 place-items-center rounded-full"
              style={{ border: "1px solid rgba(251,247,240,.22)" }}
            >
              <ArrowUp size={13} />
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
}
